import { createVuetify } from "vuetify";
import "vuetify/styles"

export default createVuetify({
  theme: {
    // options: {
    //   customProperties: true,
    // },
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        variables: {},
        colors: {
          primary: '#364563',
          secondary: '#b9b9b9',
          neutral: '#979797',
          accent: '#465593',
          error: "#FF5252" /* light red*/,
          info: "#2196F3" /* blue*/,
          success: "#4CAF50" /* green */,
          warning: "#FFC107" /* yellow */,
        },
      },
    },
  },
});
